export const translations = {
  en: {
    // Navbar
    nav: {
      home: "Home",
      inventory: "Inventory",
      financing: "Financing",
      applyFinancing: "Apply for Financing",
      loanCalculator: "Loan Calculator",
      services: "Services",
      tradeIn: "Trade In",
      scheduleService: "Schedule Service",
      contact: "Contact",
      viewInventory: "View Inventory",
    },

    chat: {
      name: "Francisco",
      title: "Francisco",
      subtitle: "Sales assistant",
      welcome: "Hi, I'm Francisco at Drive Now Autohaus. I can help with hours, inventory, financing, trade-ins, and test drives.",
      placeholder: "Ask about a vehicle or hours…",
      send: "Send",
      stop: "Stop",
      open: "Chat with Francisco",
      close: "Close chat",
      waking: "Francisco is waking up…",
      unavailable: "Francisco is temporarily unavailable. Call 708-222-6100.",
      disclaimer: "Francisco can make mistakes. Availability and price confirmed by the dealership.",
      leadName: "Name",
      leadPhone: "Phone",
      leadEmail: "Email",
      leadVehicle: "Vehicle of interest",
      leadSubmit: "Send my info",
      leadThanks: "Thanks — someone will follow up.",
      consentBefore: "By checking this box I agree to dealership",
      contactPolicy: "contact policy",
      consentAnd: "and",
      privacyPolicy: "Privacy policy",
      contactPolicyTitle: "Contact policy",
      contactPolicyBody: "I agree to receive SMS/text messages and calls from Drive Now Autohaus about my vehicle inquiry, appointment confirmations, and follow-ups. Message frequency varies. Msg & data rates may apply. Reply STOP to cancel, HELP for help.",
      healthFail: "Chat is offline. Call 708-222-6100.",
      statusOnline: "Online",
      statusOffline: "Offline",
    },

    // Hero Section
    hero: {
      tagline: "Cicero's Premier Pre-Owned Collection",
      title: "Drive Now",
      subtitle: "Autohaus",
      description: "Discover exceptional pre-owned vehicles meticulously selected for discerning drivers. Every car tells a story—find yours today.",
      exploreBtn: "Explore Collection",
      scheduleBtn: "Schedule Visit",
      vehiclesSold: "Vehicles Sold",
      satisfaction: "Satisfaction",
      yearsExperience: "Years Experience",
    },

    // Why Choose Us
    whyChoose: {
      title: "Why Choose",
      titleAccent: "Drive Now",
      description: "We're not just selling cars—we're building relationships. Our commitment to excellence sets us apart.",
      qualityTitle: "Quality Assured",
      qualityDesc: "Every vehicle undergoes a comprehensive 150-point inspection before joining our collection.",
      transparentTitle: "Transparent Pricing",
      transparentDesc: "No hidden fees, no surprises. What you see is what you pay, guaranteed.",
      serviceTitle: "Exceptional Service",
      serviceDesc: "Our dedicated team provides personalized attention from first inquiry to final delivery.",
      warrantyTitle: "Warranty Protection",
      warrantyDesc: "Drive with confidence knowing your purchase is backed by comprehensive coverage.",
      certifiedVehicles: "Customer Satisfaction is what we thrive for",
      happyCustomers: "Happy Customers",
      customWarranty: "Custom",
      dealershipWarranty: "Dealership Warranty Available",
      googleRating: "Google Rating",
    },

    // Featured Vehicles
    featured: {
      title: "Featured",
      titleAccent: "Vehicles",
      description: "Hand-picked excellence from our premium collection",
      viewAll: "View All Inventory",
      available: "Available",
      pending: "Pending",
      sold: "Sold",
      viewDetails: "View Details",
      compare: "Compare",
      selected: "Selected",
      badge: "Featured",
    },

    // Contact Section
    contact: {
      title: "Get in",
      titleAccent: "Touch",
      description: "Ready to find your perfect vehicle? Our team is here to help you every step of the way.",
      location: "Location",
      phone: "Phone",
      email: "Email",
      hours: "Hours",
      respondWithin24hrs: "We respond within 24hrs",
      hoursMonSat: "Mon-Sat: 10AM - 7PM",
      hoursSunClosed: "Sun: Closed",
      formTitle: "Send us a Message",
      nameLabel: "Full Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      phoneLabel: "Phone",
      phonePlaceholder: "(708) 222-6100",
      messageLabel: "Message",
      messagePlaceholder: "How can we help you?",
      sendBtn: "Send Message",
      sending: "Sending...",
      successMsg: "Message sent successfully! We'll get back to you soon.",
    },

    // Footer
    footer: {
      description: "Cicero's premier destination for exceptional pre-owned vehicles. Quality, transparency, and service excellence since 2018.",
      inventory: "Inventory",
      allVehicles: "All Vehicles",
      company: "Company",
      aboutUs: "About Us",
      whyChooseUs: "Why Choose Us",
      careers: "Careers",
      servicesTitle: "Services",
      warranty: "Warranty",
      serviceCenter: "Service Center",
      rights: "All rights reserved.",
      adminSignIn: "Admin Sign In",
      privacyPolicy: "Privacy Policy",
      termsAndConditions: "Terms and Conditions",
    },

    // Pre-Qualification CTA
    preQualCTA: {
      title: "Get Pre-Qualified in Minutes",
      description: "Find out what you qualify for without affecting your credit score",
      buttonText: "Get Pre-Qualified Now",
      noCreditImpact: "Safe to Check - This will not affect your credit score",
    },

    // Google Reviews (landing)
    googleReviews: {
      eyebrow: "Customer Stories",
      title: "What drivers say about us",
      description: "Real reviews from Google for {place}.",
      basedOn: "Based on {count} Google reviews",
      seeAll: "See all reviews on Google",
      attribution: "Reviews from Google",
      updated: "Updated from Google · {date}",
      viewOnGoogle: "View on Google",
      noText: "No written review.",
      loadError: "Unable to load reviews right now.",
      sectionAria: "Customer reviews from Google",
      starsAria: "{n} out of 5 stars",
      defaultPlace: "Drive Now Autohaus",
      prevReview: "Previous review",
      nextReview: "Next review",
      reviewOf: "{current} of {total}",
    },

    // Featured YouTube video (landing)
    featuredVideo: {
      eyebrow: "Built on Trust",
      title: "See why people",
      titleAccent: "trust us",
      description:
        "Get to know us better — the people, the process, and why drivers choose Drive Now Autohaus.",
      watchOnYoutube: "Watch on YouTube",
      playAria: "Play video",
      sectionAria: "Featured video",
    },

    // Inventory Page
    inventory: {
      title: "Our Inventory",
      description: "Discover our curated collection of premium pre-owned vehicles. Each car undergoes rigorous inspection to meet our exceptional standards.",
      qualityNotice: "Transparency and quality are our top priorities. Every vehicle is fully inspected, maintained, and professionally serviced to the highest standards before it reaches our inventory, delivering dependable performance and lasting confidence.",
      searchPlaceholder: "Search by make, model, or year...",
      keyword: "Keyword",
      search: "Search",
      filters: "Filters",
      resetAll: "Reset All",
      make: "Make",
      allMakes: "All Makes",
      model: "Model",
      allModels: "All Models",
      trim: "Trim",
      allTrims: "All Trims",
      priceRange: "Price Range",
      year: "Year",
      mileage: "Mileage",
      maxMileage: "Max Mileage",
      miles: "miles",
      fuelType: "Fuel Type",
      allTypes: "All Types",
      sortBy: "Sort By",
      priceLowHigh: "Price: Low to High",
      priceHighLow: "Price: High to Low",
      newestFirst: "Newest First",
      lowestMileage: "Lowest Mileage",
      vehiclesFound: "vehicles found",
      perPage: "per page",
      page: "Page",
      of: "of",
      prevPage: "Previous",
      nextPage: "Next",
      getQuote: "Get a Quote",
      noVehicles: "No vehicles match your criteria",
      resetFilters: "Reset Filters",
      clearSelection: "Clear selection",
      compareBtn: "Compare",
      selectMore: "Select up to",
      more: "more",
      moreFilters: "More Filters",
      moreFiltersDescription: "Refine by condition, body type, colors, fuel, drivetrain, and more.",
      clearExtraFilters: "Clear extra filters",
      applyFilters: "Apply Filters",
      cancel: "Cancel",
      condition: "Condition",
      allConditions: "All Conditions",
      bodyType: "Body Type",
      allBodyTypes: "All Body Types",
      bodyGroups: {
        suv: "All SUVs",
        sedan: "All sedans",
        truck: "All trucks",
        pickup: "All pickups",
        hatchback: "All hatchbacks",
        coupe: "All coupes",
        van: "All vans",
        camioneta: "All SUVs and trucks",
      },
      exteriorColor: "Exterior Color",
      allColors: "All Colors",
      interior: "Interior",
      allInteriors: "All Interiors",
      cylinders: "Cylinders",
      allCylinders: "All",
      drivetrain: "Drive Train",
      allDrivetrains: "All",
      allTransmissions: "All",
      allOption: "All",
      values: {
        conditionNew: "New",
        conditionUsed: "Used",
        conditionCertified: "Certified Pre-Owned",
        fuelGasoline: "Gasoline",
        fuelElectric: "Electric",
        fuelDiesel: "Diesel",
        fuelHybrid: "Hybrid",
        transmissionAutomatic: "Automatic",
        drivetrainFwd: "FWD",
        drivetrainRwd: "RWD",
        drivetrainAwd: "AWD",
        drivetrain4wd: "4WD",
        drivetrainFront: "Front-Wheel Drive",
        drivetrainRear: "Rear-Wheel Drive",
        drivetrainAll: "All-Wheel Drive",
        drivetrainFour: "Four-Wheel Drive",
      },
    },

    // Financing Page
    financing: {
      tagline: "Finance Your Dream Car",
      title: "Apply for Financing",
      description: "Complete the secure credit application below. It is submitted directly to our finance partners so you only enter your information once.",
      iframeTitle: "Finance Driver credit application",
      iframeOpenApp: "Open credit application",
      iframeMobileHint: "On phones, the credit application opens in a new tab for the best experience.",
      iframeFallback: "Application not loading? Open in a new tab.",
      iframeGuideTitle: "Reading the English credit form",
      iframeGuideIntro: "The credit application is provided by Dealertrack and stays in English. Use this list to match Spanish terms to the labels on the form, or open the form in a new tab and translate it with your browser.",
      iframeGuideUse: "You can also fill the English fields using this guide.",
      iframeTranslateBtn: "Open form to translate in browser",
      iframeTranslateAfter: "In the new tab, translate the page with your browser (this is the method that works):",
      iframeTranslateStepDesktop: "Computer (Chrome or Edge): right-click the page → Translate to Spanish. Or click the Translate icon in the address bar.",
      iframeTranslateStepIphone: "iPhone / iPad: tap AA in the address bar → Translate to Spanish.",
      iframeTranslateStepAndroid: "Android: tap the ⋮ menu → Translate.",
      iframeTranslateWarning: "Browser Translate only changes what you see. Submit on that same Dealertrack tab so your information goes to the dealership, not through a Google website.",
      iframeOnForm: "On the form (English)",
      iframeInSpanish: "Spanish",
      email: "Email",
      itin: "ITIN (if no SSN)",
      residenceTitle: "Residence",
      coApplicant: "Co-applicant",
      disclosures: "Acknowledgments and consent",
      section1Title: "Section 1: Applicant Information",
      section1Subtitle: "Personal details of the primary applicant",
      section2Title: "Section 2: Applicant Employment Information",
      section2Subtitle: "Current employment details",
      section3Title: "Section 3: Vehicle Information",
      section3Subtitle: "Details about the vehicle you're interested in (optional)",
      selectInventoryVehicle: "Select Vehicle from Inventory",
      selectInventoryVehiclePlaceholder: "Choose an available vehicle...",
      manualVehicleEntry: "Other / Enter manually",
      selectInventoryVehicleHint: "Selecting a vehicle fills stock number, year, make, model, trim, VIN, and mileage automatically. You can still edit any field.",
      loadingInventory: "Loading inventory...",
      inventoryLoadError: "Failed to load inventory vehicles",
      coBuyerTitle: "Co-Buyer Information",
      coBuyerSubtitle: "Personal details of the co-buyer",
      coBuyerEmploymentTitle: "Co-Buyer Employment Information",
      coBuyerEmploymentSubtitle: "Current employment details of the co-buyer",
      commentsTitle: "Additional Comments",
      commentsSubtitle: "Any additional information you'd like to share",
      consentTitle: "Acknowledgment and Consent",
      consentSubtitle: "Please review and accept the following agreements",
      addCoBuyer: "Add Co-Buyer",
      submitBtn: "Submit Application",
      submitting: "Submitting Application...",
      consentRequired: "Please accept both consent agreements to submit your application.",
      compulsoryFieldsRequired: "Please Fill in all the Compulsory Fields that the Financing Application requires",
      skippedCountInSection: "{count} compulsory field(s) skipped in {section}",
      fieldIsRequired: "{label} is required",
      viewField: "View field",
      // Form fields
      firstName: "First Name",
      middleName: "Middle Name",
      lastName: "Last Name",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "City",
      state: "State",
      selectState: "Select State",
      zipCode: "ZIP Code",
      ssn: "Social Security Number",
      dateOfBirth: "Date of Birth",
      driverLicense: "Driver License Number",
      dlState: "Driver License State",
      dlIssuingCounty: "DL Issuing County",
      dlExpiry: "Driver License Expiry",
      mobileNumber: "Mobile Number",
      homeNumber: "Home Number",
      residenceYears: "Time at Residence - Years",
      residenceMonths: "Time at Residence - Months",
      residenceType: "Residence Type",
      selectType: "Select Type",
      rentMortgage: "Rent/Mortgage (Monthly)",
      employer: "Employer",
      employerType: "Employer Type",
      monthlyIncome: "Monthly Income",
      occupation: "Occupation",
      empAddress1: "Employer Address Line 1",
      empAddress2: "Employer Address Line 2",
      workPhone: "Work Phone",
      jobYears: "Time on Job - Years",
      jobMonths: "Time on Job - Months",
      landlordName: "Current Landlord Name",
      landlordNumber: "Current Landlord Number",
      previousResidenceTitle: "Previous Residential Information",
      previousResidenceSubtitle: "Required because time at your current residence is less than 2 years.",
      previousStreetAddress: "Previous Street Address",
      previousResidenceYears: "Years Stayed",
      previousResidenceMonths: "Months Stayed",
      previousRentMortgage: "Monthly Rent / Mortgage",
      previousResidenceRequired: "Please complete all previous residential information fields.",
      previousEmploymentTitle: "Previous Employment Information",
      previousEmploymentSubtitle: "Required because time on your current job is less than 2 years.",
      previousEmployer: "Previous Employer",
      previousJobYears: "Employment Years",
      previousJobMonths: "Employment Months",
      previousEmploymentRequired: "Please complete all previous employment information fields.",
      stockNumber: "Stock Number",
      vehicleYear: "Year",
      vehicleMake: "Make",
      vehicleModel: "Model",
      trim: "Trim",
      vin: "VIN",
      mileage: "Mileage",
    },

    // Trade-In Page
    tradeIn: {
      tagline: "Get Top Dollar for Your Vehicle",
      title: "Trade In Your Vehicle",
      description: "Tell us about your current vehicle and we'll provide you with a competitive trade-in offer. Our team will evaluate your submission and contact you within 24 hours.",
      section1Title: "Section 1: Personal Information",
      section1Subtitle: "Your contact details",
      section2Title: "Section 2: Vehicle Information",
      section2Subtitle: "Details about your trade-in vehicle",
      section3Title: "Section 3: Vehicle Features",
      section3Subtitle: "Select all features that apply to your vehicle",
      section4Title: "Section 4: Vehicle Description and Comments",
      section4Subtitle: "Provide additional details about your vehicle's condition",
      consentTitle: "Acknowledgment and Consent",
      consentSubtitle: "Please review and accept the following agreement",
      submitBtn: "Submit Information",
      submitting: "Submitting Information...",
      featuresSelected: "features selected",
      featureSelected: "feature selected",
      vinPlaceholder: "17-character VIN",
      yearPlaceholder: "e.g., 2022",
      makePlaceholder: "e.g., Toyota",
      modelPlaceholder: "e.g., Camry",
      trimPlaceholder: "e.g., XSE",
      mileagePlaceholder: "e.g., 45000",
      colourPlaceholder: "e.g., Silver",
      cylinders: "Cylinders",
      selectCylinders: "Select Cylinders",
      selectTransmission: "Select Transmission",
      selectOption: "Select Option",
      financed: "Financed",
      financedWith: "Financed with Whom",
      payOffAmount: "Pay Off Amount",
      accidents: "Accidents",
      descriptionPlaceholder: "Describe the overall condition of your vehicle, any modifications, recent repairs, or any other relevant information...",
    },

    // Pre-Qualification Page
    preQual: {
      tagline: "Quick & Easy Pre-Approval",
      title: "Get Pre-Qualified",
      description: "Answer a few simple questions to see if you pre-qualify for financing. This will not affect your credit score.",
      startBtn: "Start Pre-Qualification",
      step: "Step",
      of: "of",
      nextBtn: "Next",
      previousBtn: "Previous",
      submitBtn: "Submit Application",
      submitting: "Submitting...",
      // Steps
      step1Title: "Personal Information",
      step2Title: "Employment & Income",
      step3Title: "Credit Information",
      step4Title: "Vehicle Interest",
      // Fields
      fullName: "Full Name",
      fullNamePlaceholder: "Your full legal name",
      phone: "Phone Number",
      phonePlaceholder: "(708) 222-6100",
      email: "Email Address",
      emailPlaceholder: "your@email.com",
      address: "Current Address",
      addressPlaceholder: "5401 W Cermak Rd, Cicero, IL 60804",
      dob: "Date of Birth",
      jobDuration: "How long at current job?",
      selectDuration: "Select duration",
      monthlyIncome: "Monthly Income (before taxes)",
      incomePlaceholder: "Enter amount",
      hasAutoLoan: "Do you currently have an auto loan?",
      yes: "Yes",
      no: "No",
      loanBalance: "What is your current loan balance?",
      creditScore: "What is your estimated credit score?",
      selectScore: "Select range",
      hasCollections: "Do you have any collections on your credit?",
      collectionsDetails: "Please provide details about collections",
      hasBankruptcies: "Do you have any open bankruptcies?",
      bankruptcyDetails: "Please provide details about bankruptcies",
      hasRepossession: "Have you ever had a vehicle repossessed?",
      repossessionTime: "When did this occur?",
      interestedVehicle: "What type of vehicle are you interested in?",
      vehiclePlaceholder: "e.g., SUV, Sedan, Truck",
      budget: "What is your budget?",
      budgetPlaceholder: "Enter your budget",
      downPayment: "How much can you put down?",
      downPaymentPlaceholder: "Enter down payment",
      payTaxesUpfront: "Can you pay taxes, title, and license upfront?",
      consentTitle: "Acknowledgment and Consent",
    },

    // Loan Calculator Page
    loanCalc: {
      tagline: "Plan Your Purchase",
      title: "Loan Calculator",
      description: "Use our calculator to estimate your monthly payments and find a financing plan that fits your budget.",
      vehiclePrice: "Vehicle Price",
      downPayment: "Down Payment",
      tradeInValue: "Trade-In Value",
      interestRate: "Interest Rate (APR)",
      loanTerm: "Loan Term",
      months: "months",
      monthlyPayment: "Estimated Monthly Payment",
      loanAmount: "Loan Amount",
      totalInterest: "Total Interest",
      totalCost: "Total Cost",
      applyNow: "Apply for Financing Now",
      disclaimer: "This calculator provides estimates only. Actual rates and terms may vary based on creditworthiness and other factors. Contact us for accurate quotes.",
    },

    // Schedule Service Page
    scheduleService: {
      tagline: "Expert Care for Your Vehicle",
      title: "Schedule Service",
      description: "Our certified technicians are ready to keep your vehicle running at its best. Schedule your service appointment today.",
      section1Title: "Contact Information",
      section1Subtitle: "How can we reach you?",
      section2Title: "Vehicle Information",
      section2Subtitle: "Tell us about your vehicle",
      section3Title: "Service Details",
      section3Subtitle: "What can we help you with?",
      consentTitle: "Acknowledgment and Consent",
      consentSubtitle: "Please review and accept the following agreement",
      submitBtn: "Schedule Service",
      submitting: "Scheduling...",
      problemDescription: "Describe the Problem",
      problemPlaceholder: "Please describe any issues, symptoms, or services needed...",
      preferredDate: "Preferred Service Date",
      preferredTime: "Preferred Time",
      preferredTimeOfContact: "Preferred time of Contact",
      vehicleBodyType: "What is your Vehicle's Body type?",
      vehicleBodyPlaceholder: "e.g., SUV, Sedan, Truck",
      selectTime: "Select time",
      successMsg: "Service appointment scheduled successfully! We'll contact you within 24 hours to confirm your appointment.",
    },

    // Vehicle Modal
    vehicleModal: {
      specifications: "Specifications",
      year: "Year",
      mileage: "Mileage",
      fuelType: "Fuel Type",
      transmission: "Transmission",
      drivetrain: "Drivetrain",
      exteriorColor: "Exterior",
      interiorColor: "Interior",
      engine: "Engine",
      features: "Features",
      trim: "Trim",
      bodyType: "Body Type",
      condition: "Condition",
      cylinders: "Cylinders",
      cityMpg: "City MPG",
      highwayMpg: "Highway MPG",
      viewMoreDetails: "View More Details",
      hideDetails: "Hide Details",
      viewVehicleDescription: "View Vehicle Description",
      hideVehicleDescription: "Hide Vehicle Description",
      viewVehiclePage: "View Vehicle Page",
      descriptionHeading: "Vehicle Description",
      getQuote: "Get a Quote",
      quotePrompt: "Fill out the vehicle inquiry form below to receive a quote.",
      interestedTitle: "Inquire About This Vehicle",
      interestedDesc: "Fill out the form below and we'll get back to you shortly.",
      namePlaceholder: "Your name",
      emailPlaceholder: "your@email.com",
      phonePlaceholder: "(708) 222-6100",
      messagePlaceholder: "I'm interested in this vehicle...",
      preferredContact: "Preferred Contact Method",
      sendInquiry: "Send Inquiry",
      sending: "Sending...",
      orCall: "Call",
      // Predefined field values (English display; Spanish block maps these)
      values: {
        conditionNew: "New",
        conditionUsed: "Used",
        conditionCertified: "Certified Pre-Owned",
        fuelGasoline: "Gasoline",
        fuelElectric: "Electric",
        fuelDiesel: "Diesel",
        fuelHybrid: "Hybrid",
        transmissionAutomatic: "Automatic",
      },
    },

    vehiclePage: {
      breadcrumbInventory: "Inventory",
      photos: "Photos",
      videos: "Videos",
      photoOf: "of",
      specifications: "Full specifications",
      overview: "Overview",
      highlights: "Highlights",
      features: "Features & equipment",
      stock: "Stock",
      vin: "VIN",
      plusFees: "Plus taxes & fees",
      callDealership: "Call the dealership",
      applyFinancing: "Apply for financing",
      copyLink: "Copy vehicle link",
      linkCopied: "Vehicle link copied",
      share: "Share",
      backToInventory: "Back to inventory",
      notFound: "This vehicle is no longer listed.",
      notFoundHint: "It may have been sold or removed. Browse the current inventory.",
      browseInventory: "Browse inventory",
      inquireHeading: "Interested in this vehicle?",
      inquireHint: "Send a message and our team will follow up shortly.",
      noPhotos: "Photos coming soon",
      noFeatures: "Ask our team for the full equipment list.",
      locationLabel: "Visit us",
      address: "5401 W Cermak Rd, Cicero, IL 60804",
      hours: "Mon–Sat 10AM – 7PM",
      loading: "Loading vehicle…",
    },

    // Compare Modal
    compare: {
      title: "Compare Vehicles",
      vehiclesSelected: "vehicles selected",
      vehicleSelected: "vehicle selected",
      specifications: "Specifications",
      features: "Features",
      price: "Price",
      year: "Year",
      mileage: "Mileage",
      fuelType: "Fuel Type",
      transmission: "Transmission",
      drivetrain: "Drivetrain",
      exteriorColor: "Exterior Color",
      interiorColor: "Interior Color",
      engine: "Engine",
      status: "Status",
      compareUpTo: "Compare up to 3 vehicles side by side",
      doneComparing: "Done Comparing",
    },

    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      required: "Required",
      optional: "Optional",
      submit: "Submit",
      cancel: "Cancel",
      close: "Close",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      back: "Back",
      next: "Next",
      previous: "Previous",
      yes: "Yes",
      no: "No",
    },

    // Consent Texts
    consent: {
      acknowledgment: "ACKNOWLEDGMENT AND CONSENT:",
      financingConsent1: "I certify that the above information is complete and accurate to the best of my knowledge. Creditors receiving this application will retain the application whether or not it is approved. Creditors may rely on this application in deciding whether to grant the requested credit. False statements may subject me to criminal penalties. I authorize the creditors to obtain credit reports about me on an ongoing basis during this credit transaction and to check my credit and employment history on an ongoing basis during the term of the credit transaction. If this application is approved, I authorize the creditor to give credit information about me to its affiliates.",
      financingConsent2: "By checking this box I hereby consent to receive customer care text messages and/or phone calls from or on behalf of Drive Now Autohaus or their employees to the mobile phone number I provided above. By opting in, I understand that message and data rates may apply. This acknowledgement constitutes my written consent to receive text messages to my cell phone and phone calls, including communications sent using an auto-dialer or pre-recorded message. You may withdraw your consent at any time by texting \"STOP\" or \"HELP\" for help. See our",
      privacyPolicy: "privacy policy",
      privacyPolicyTitle: "Privacy Policy",
      ackAndConsentLink: "Acknowledgement and Consent",
      agreeTo: "I have read and agree to the",
      and: "and",
      forMoreInfo: "for more information.",
      tradeInConsent: "By checking this box I hereby consent to receive customer care text messages and/or phone calls from or on behalf of Drive Now Autohaus or their employees to the mobile phone number I provided above. By opting in, I understand that message and data rates may apply. This acknowledgement constitutes my written consent to receive text messages to my cell phone and phone calls, including communications sent using an auto-dialer or pre-recorded message. You may withdraw your consent at any time by texting \"STOP\" or \"HELP\" for help. See our",
      serviceConsent: "By checking this box, you expressly consent to receive customer care text messages and/or phone calls to the number provided from or on behalf of Drive Now Autohaus or their employees in response to your inquiry. By opting in, you understand no mobile information will be shared with third parties or affiliates for marketing or promotional purposes. Message frequency varies per user. Message and data rates may apply. You may withdraw your consent at any time by texting \"STOP\" or \"HELP\" for help. See our Privacy Policy for more information.",
      formRequired: "Please agree to receive SMS/text messages and calls from Drive Now Autohaus",
      smsProgramNotice: "I agree to receive SMS/text messages and calls from Drive Now Autohaus about my vehicle inquiry, appointment confirmations, and follow-ups. Message frequency varies. Msg & data rates may apply. Reply STOP to cancel, HELP for help. See",
    },

    // How It Works (Loan Calculator)
    howItWorks: {
      title: "How It Works",
      step1Title: "1. Enter Details",
      step1Desc: "Input your desired loan amount, down payment, interest rate, and loan term.",
      step2Title: "2. Calculate",
      step2Desc: "Our calculator uses industry-standard formulas to compute your monthly payment.",
      step3Title: "3. Plan Ahead",
      step3Desc: "Review the breakdown and adjust values to find a payment that fits your budget.",
    },

    // Vehicle Features (Trade-In)
    vehicleFeatures: {
      "4x4": "4x4",
      "adjustablePedals": "Adjustable Pedals",
      "airConditioning": "Air Conditioning",
      "airConditionedSeats": "Air Conditioned Seats",
      "alarmSystem": "Alarm System",
      "alloyWheels": "Alloy Wheels",
      "amFm": "AM/FM",
      "antiLockBrakes": "Anti-Lock Brakes",
      "autoClimateControl": "Auto Climate Control",
      "backUpSonar": "Backup Camera",
      "bedCover": "Bed Cover",
      "bedliner": "Bedliner",
      "bluetooth": "Bluetooth",
      "bucketSeats": "Bucket Seats",
      "cd": "CD",
      "cdChanger": "CD Changer",
      "convertibleTop": "Convertible Top",
      "cruiseControl": "Cruise Control",
      "diesel": "Diesel",
      "driverAirbag": "Driver Airbag",
      "extraCab": "Extra Cab",
      "fogLights": "Fog Lights",
      "heatedSeats": "Heated Seats",
      "keylessEntry": "Keyless Entry",
      "leatherSeats": "Leather Seats",
      "luggageRack": "Luggage Rack",
      "memorySeats": "Memory Seats",
      "navigation": "Navigation",
      "passengerAirbag": "Passenger Airbag",
      "powerDoors": "Power Doors",
      "powerLocks": "Power Locks",
      "powerMirrors": "Power Mirrors",
      "powerSeats": "Power Seats",
      "powerTailgate": "Power Tailgate",
      "powerWindows": "Power Windows",
      "quadSeats": "Quad Seats",
      "rearAir": "Rear Air",
      "rearDefroster": "Rear Defroster",
      "rearSpoiler": "Rear Spoiler",
      "runningBoards": "Running Boards",
      "satelliteRadio": "Satellite Radio",
      "sideAirbags": "Side Airbags",
      "sunRoof": "Sunroof",
      "thirdRowSeat": "Third Row Seat",
      "tiltWheel": "Tilt Wheel",
      "tintedWindows": "Tinted Windows",
      "toolBox": "Tool Box",
      "towPackage": "Tow Package",
      "tractionControl": "Traction Control",
      "tvDvd": "TV/DVD",
      "tvVcr": "TV/VCR",
      "woodgrain": "Woodgrain",
      "usbPort": "USB Port",
      "appleCarPlay": "Apple CarPlay",
      "androidAuto": "Android Auto",
      "laneDepartureWarning": "Lane Departure Warning",
      "laneDepartureAlert": "Lane Departure Alert",
      "blindSpotMonitor": "Blind Spot Monitor",
      "premiumSound": "Premium Sound",
      "pushButtonStart": "Push Button Start",
      "remoteStart": "Remote Start",
      "sportSuspension": "Sport Suspension",
      "ledHeadlights": "LED Headlights",
      "adaptiveCruiseControl": "Adaptive Cruise Control",
      "rearviewCamera": "Rearview Camera",
      "parkingAssist": "Parking Assist",
      "wirelessCharging": "Wireless Charging",
      "touchscreen": "Touchscreen",
      "premiumAudio": "Premium Audio",
      "heatedSteeringWheel": "Heated Steering Wheel",
      "ventilatedSeats": "Ventilated Seats",
      "automaticBraking": "Automatic Braking",
    },
  },

  es: {
    // Navbar
    nav: {
      home: "Inicio",
      inventory: "Inventario",
      financing: "Financiamiento",
      applyFinancing: "Solicitar Financiamiento",
      loanCalculator: "Calculadora de Préstamos",
      services: "Servicios",
      tradeIn: "Intercambio",
      scheduleService: "Agendar Servicio",
      contact: "Contacto",
      viewInventory: "Ver Inventario",
    },

    chat: {
      name: "Francisco",
      title: "Francisco",
      subtitle: "Asistente de ventas",
      welcome: "Hola, soy Francisco de Drive Now Autohaus. Puedo ayudar con horario, inventario, financiamiento, recibo de vehículo y pruebas de manejo.",
      placeholder: "Pregunte por un vehículo o el horario…",
      send: "Enviar",
      stop: "Detener",
      open: "Chatear con Francisco",
      close: "Cerrar chat",
      waking: "Francisco se está iniciando…",
      unavailable: "Francisco no está disponible por el momento. Llame al 708-222-6100.",
      disclaimer: "Francisco puede equivocarse. Disponibilidad y precio los confirma el concesionario.",
      leadName: "Nombre",
      leadPhone: "Teléfono",
      leadEmail: "Correo",
      leadVehicle: "Vehículo de interés",
      leadSubmit: "Enviar mis datos",
      leadThanks: "Gracias — alguien le contactará.",
      consentBefore: "Al marcar esta casilla acepto la",
      contactPolicy: "política de contacto",
      consentAnd: "del concesionario y la",
      privacyPolicy: "Política de privacidad",
      contactPolicyTitle: "Política de contacto",
      contactPolicyBody: "Acepto recibir mensajes SMS/texto y llamadas de Drive Now Autohaus sobre mi consulta de vehículo, confirmaciones de citas y seguimientos. La frecuencia de los mensajes varía. Pueden aplicar tarifas de mensajes y datos. Responda STOP para cancelar, HELP para ayuda.",
      healthFail: "El chat está fuera de línea. Llame al 708-222-6100.",
      statusOnline: "En línea",
      statusOffline: "Fuera de línea",
    },

    // Hero Section
    hero: {
      tagline: "La Colección Premium de Cicero",
      title: "Drive Now",
      subtitle: "Autohaus",
      description: "Descubra vehículos excepcionales meticulosamente seleccionados para conductores exigentes. Cada auto cuenta una historia—encuentre la suya hoy.",
      exploreBtn: "Explorar Colección",
      scheduleBtn: "Agendar Visita",
      vehiclesSold: "Vehículos Vendidos",
      satisfaction: "Satisfacción",
      yearsExperience: "Años de Experiencia",
    },

    // Why Choose Us
    whyChoose: {
      title: "Por Qué Elegir",
      titleAccent: "Drive Now",
      description: "No solo vendemos autos—construimos relaciones. Nuestro compromiso con la excelencia nos distingue.",
      qualityTitle: "Calidad Garantizada",
      qualityDesc: "Cada vehículo pasa por una inspección completa de 150 puntos antes de unirse a nuestra colección.",
      transparentTitle: "Precios Transparentes",
      transparentDesc: "Sin cargos ocultos, sin sorpresas. Lo que ve es lo que paga, garantizado.",
      serviceTitle: "Servicio Excepcional",
      serviceDesc: "Nuestro equipo dedicado brinda atención personalizada desde la primera consulta hasta la entrega final.",
      warrantyTitle: "Protección de Garantía",
      warrantyDesc: "Conduzca con confianza sabiendo que su compra está respaldada por cobertura completa.",
      certifiedVehicles: "La satisfacción del cliente es lo que buscamos",
      happyCustomers: "Clientes Satisfechos",
      customWarranty: "Garantía",
      dealershipWarranty: "Garantía del Concesionario Disponible",
      googleRating: "Calificación de Google",
    },

    // Featured Vehicles
    featured: {
      title: "Vehículos",
      titleAccent: "Destacados",
      description: "Excelencia seleccionada de nuestra colección premium",
      viewAll: "Ver Todo el Inventario",
      available: "Disponible",
      pending: "Pendiente",
      sold: "Vendido",
      viewDetails: "Ver Detalles",
      compare: "Comparar",
      selected: "Seleccionado",
      badge: "Destacado",
    },

    // Contact Section
    contact: {
      title: "Póngase en",
      titleAccent: "Contacto",
      description: "¿Listo para encontrar su vehículo perfecto? Nuestro equipo está aquí para ayudarle en cada paso.",
      location: "Ubicación",
      phone: "Teléfono",
      email: "Correo",
      hours: "Horario",
      respondWithin24hrs: "Respondemos en 24 horas",
      hoursMonSat: "Lun-Sáb: 10AM - 7PM",
      hoursSunClosed: "Dom: Cerrado",
      formTitle: "Envíenos un Mensaje",
      nameLabel: "Nombre Completo",
      namePlaceholder: "Su nombre",
      emailLabel: "Correo Electrónico",
      emailPlaceholder: "su@correo.com",
      phoneLabel: "Teléfono",
      phonePlaceholder: "(708) 222-6100",
      messageLabel: "Mensaje",
      messagePlaceholder: "¿Cómo podemos ayudarle?",
      sendBtn: "Enviar Mensaje",
      sending: "Enviando...",
      successMsg: "¡Mensaje enviado exitosamente! Nos pondremos en contacto pronto.",
    },

    // Footer
    footer: {
      description: "El destino premier de Cicero para vehículos usados excepcionales. Calidad, transparencia y excelencia en servicio desde 2018.",
      inventory: "Inventario",
      allVehicles: "Todos los Vehículos",
      company: "Compañía",
      aboutUs: "Sobre Nosotros",
      whyChooseUs: "Por Qué Elegirnos",
      careers: "Carreras",
      servicesTitle: "Servicios",
      warranty: "Garantía",
      serviceCenter: "Centro de Servicio",
      rights: "Todos los derechos reservados.",
      adminSignIn: "Acceso Admin",
      privacyPolicy: "Política de Privacidad",
      termsAndConditions: "Términos y Condiciones",
    },

    // Pre-Qualification CTA
    preQualCTA: {
      title: "Pre-Califique en Minutos",
      description: "Descubra para qué califica sin afectar su puntaje de crédito",
      buttonText: "Pre-Califique Ahora",
      noCreditImpact: "Seguro de verificar - Esto no afectará su puntaje de crédito",
    },

    // Google Reviews (landing)
    googleReviews: {
      eyebrow: "Historias de Clientes",
      title: "Lo que dicen de nosotros",
      description: "Reseñas reales de Google para {place}.",
      basedOn: "Basado en {count} reseñas de Google",
      seeAll: "Ver todas las reseñas en Google",
      attribution: "Reseñas de Google",
      updated: "Actualizado desde Google · {date}",
      viewOnGoogle: "Ver en Google",
      noText: "Sin reseña escrita.",
      loadError: "No se pueden cargar las reseñas en este momento.",
      sectionAria: "Reseñas de clientes de Google",
      starsAria: "{n} de 5 estrellas",
      defaultPlace: "Drive Now Autohaus",
      prevReview: "Reseña anterior",
      nextReview: "Reseña siguiente",
      reviewOf: "{current} de {total}",
    },

    // Featured YouTube video (landing)
    featuredVideo: {
      eyebrow: "Basados en la Confianza",
      title: "Vea por qué la gente",
      titleAccent: "confía en nosotros",
      description:
        "Conózcanos mejor — las personas, el proceso y por qué los conductores eligen Drive Now Autohaus.",
      watchOnYoutube: "Ver en YouTube",
      playAria: "Reproducir video",
      sectionAria: "Video destacado",
    },

    // Inventory Page
    inventory: {
      title: "Nuestro Inventario",
      description: "Descubra nuestra colección curada de vehículos usados premium. Cada auto pasa por una inspección rigurosa para cumplir con nuestros estándares excepcionales.",
      qualityNotice: "La transparencia y la calidad son nuestras máximas prioridades. Cada vehículo es inspeccionado, mantenido y revisado profesionalmente con los más altos estándares antes de llegar a nuestro inventario, ofreciendo un rendimiento confiable y una confianza duradera.",
      searchPlaceholder: "Buscar por marca, modelo o año...",
      keyword: "Palabra Clave",
      search: "Buscar",
      filters: "Filtros",
      resetAll: "Restablecer Todo",
      make: "Marca",
      allMakes: "Todas las Marcas",
      model: "Modelo",
      allModels: "Todos los Modelos",
      trim: "Versión",
      allTrims: "Todas las Versiones",
      priceRange: "Rango de Precio",
      year: "Año",
      mileage: "Millaje",
      maxMileage: "Millaje Máximo",
      miles: "millas",
      fuelType: "Tipo de Combustible",
      allTypes: "Todos los Tipos",
      sortBy: "Ordenar Por",
      priceLowHigh: "Precio: Menor a Mayor",
      priceHighLow: "Precio: Mayor a Menor",
      newestFirst: "Más Nuevos Primero",
      lowestMileage: "Menor Millaje",
      vehiclesFound: "vehículos encontrados",
      perPage: "por página",
      page: "Página",
      of: "de",
      prevPage: "Anterior",
      nextPage: "Siguiente",
      getQuote: "Pedir cotización",
      noVehicles: "Ningún vehículo coincide con sus criterios",
      resetFilters: "Restablecer Filtros",
      clearSelection: "Limpiar selección",
      compareBtn: "Comparar",
      selectMore: "Seleccione hasta",
      more: "más",
      moreFilters: "Más Filtros",
      moreFiltersDescription: "Refine por condición, tipo de carrocería, colores, combustible, tracción y más.",
      clearExtraFilters: "Borrar filtros adicionales",
      applyFilters: "Aplicar Filtros",
      cancel: "Cancelar",
      condition: "Condición",
      allConditions: "Todas las Condiciones",
      bodyType: "Tipo de Carrocería",
      allBodyTypes: "Todos los Tipos",
      bodyGroups: {
        suv: "Todas las SUV",
        sedan: "Todos los sedanes",
        truck: "Todas las trocas",
        pickup: "Todas las pickups",
        hatchback: "Todos los hatchbacks",
        coupe: "Todos los cupés",
        van: "Todas las vans",
        camioneta: "Todas las camionetas",
      },
      exteriorColor: "Color Exterior",
      allColors: "Todos los Colores",
      interior: "Interior",
      allInteriors: "Todos los Interiores",
      cylinders: "Cilindros",
      allCylinders: "Todos",
      drivetrain: "Tracción",
      allDrivetrains: "Todas",
      allTransmissions: "Todas",
      allOption: "Todos",
      values: {
        conditionNew: "Nuevo",
        conditionUsed: "Usado",
        conditionCertified: "Certificado Pre-Propietario",
        fuelGasoline: "Gasolina",
        fuelElectric: "Eléctrico",
        fuelDiesel: "Diésel",
        fuelHybrid: "Híbrido",
        transmissionAutomatic: "Automático",
        drivetrainFwd: "FWD",
        drivetrainRwd: "RWD",
        drivetrainAwd: "AWD",
        drivetrain4wd: "4WD",
        drivetrainFront: "Tracción Delantera",
        drivetrainRear: "Tracción Trasera",
        drivetrainAll: "Tracción Integral",
        drivetrainFour: "Tracción en las 4 Ruedas",
      },
    },

    // Financing Page
    financing: {
      tagline: "Financie el Auto de Sus Sueños",
      title: "Solicitar Financiamiento",
      description: "Complete la solicitud de crédito segura a continuación. Se envía directamente a nuestros socios de financiamiento para que solo ingrese su información una vez.",
      iframeTitle: "Solicitud de crédito Finance Driver",
      iframeOpenApp: "Abrir solicitud de crédito",
      iframeMobileHint: "En teléfonos, la solicitud de crédito se abre en una pestaña nueva para una mejor experiencia.",
      iframeFallback: "¿No carga la solicitud? Ábrala en una pestaña nueva.",
      iframeGuideTitle: "Cómo leer el formulario en inglés",
      iframeGuideIntro: "La solicitud de crédito la proporciona Dealertrack y permanece en inglés. Use esta lista para relacionar cada término en español con la etiqueta del formulario, o ábralo en una pestaña nueva y tradúzcalo con el navegador.",
      iframeGuideUse: "También puede completar los campos en inglés con esta guía.",
      iframeTranslateBtn: "Abrir el formulario para traducirlo",
      iframeTranslateAfter: "En la pestaña nueva, traduzca la página con el navegador (este es el método que funciona):",
      iframeTranslateStepDesktop: "Computadora (Chrome o Edge): clic derecho en la página → Traducir a español. O use el icono de Traducir en la barra de direcciones.",
      iframeTranslateStepIphone: "iPhone / iPad: toque AA en la barra de direcciones → Traducir a español.",
      iframeTranslateStepAndroid: "Android: toque el menú ⋮ → Traducir.",
      iframeTranslateWarning: "La traducción del navegador solo cambia lo que usted ve. Envíe la solicitud en esa misma pestaña de Dealertrack para que sus datos lleguen al concesionario, no a un sitio de Google.",
      iframeOnForm: "En el formulario (inglés)",
      iframeInSpanish: "Español",
      email: "Correo electrónico",
      itin: "ITIN (si no tiene SSN)",
      residenceTitle: "Residencia",
      coApplicant: "Co-solicitante",
      disclosures: "Reconocimientos y consentimiento",
      section1Title: "Sección 1: Información del Solicitante",
      section1Subtitle: "Datos personales del solicitante principal",
      section2Title: "Sección 2: Información de Empleo",
      section2Subtitle: "Detalles de empleo actual",
      section3Title: "Sección 3: Información del Vehículo",
      section3Subtitle: "Detalles del vehículo de su interés (opcional)",
      selectInventoryVehicle: "Seleccionar Vehículo del Inventario",
      selectInventoryVehiclePlaceholder: "Elija un vehículo disponible...",
      manualVehicleEntry: "Otro / Ingresar manualmente",
      selectInventoryVehicleHint: "Al seleccionar un vehículo se completan automáticamente el número de stock, año, marca, modelo, versión, VIN y millaje. Aún puede editar cualquier campo.",
      loadingInventory: "Cargando inventario...",
      inventoryLoadError: "No se pudo cargar el inventario de vehículos",
      coBuyerTitle: "Información del Co-Comprador",
      coBuyerSubtitle: "Datos personales del co-comprador",
      coBuyerEmploymentTitle: "Empleo del Co-Comprador",
      coBuyerEmploymentSubtitle: "Detalles de empleo del co-comprador",
      commentsTitle: "Comentarios Adicionales",
      commentsSubtitle: "Información adicional que desee compartir",
      consentTitle: "Reconocimiento y Consentimiento",
      consentSubtitle: "Por favor revise y acepte los siguientes acuerdos",
      addCoBuyer: "Agregar Co-Comprador",
      submitBtn: "Enviar Solicitud",
      submitting: "Enviando Solicitud...",
      consentRequired: "Por favor acepte ambos acuerdos de consentimiento para enviar su solicitud.",
      compulsoryFieldsRequired: "Por favor complete todos los campos obligatorios que requiere la solicitud de financiamiento",
      skippedCountInSection: "{count} campo(s) obligatorio(s) omitido(s) en {section}",
      fieldIsRequired: "{label} es obligatorio",
      viewField: "Ver campo",
      // Form fields
      firstName: "Nombre",
      middleName: "Segundo Nombre",
      lastName: "Apellido",
      addressLine1: "Dirección Línea 1",
      addressLine2: "Dirección Línea 2",
      city: "Ciudad",
      state: "Estado",
      selectState: "Seleccionar Estado",
      zipCode: "Código Postal",
      ssn: "Número de Seguro Social",
      dateOfBirth: "Fecha de Nacimiento",
      driverLicense: "Número de Licencia",
      dlState: "Estado de Licencia",
      dlIssuingCounty: "Condado Emisor de Licencia",
      dlExpiry: "Vencimiento de Licencia",
      mobileNumber: "Teléfono Móvil",
      homeNumber: "Teléfono de Casa",
      residenceYears: "Tiempo en Residencia - Años",
      residenceMonths: "Tiempo en Residencia - Meses",
      residenceType: "Tipo de Residencia",
      selectType: "Seleccionar Tipo",
      rentMortgage: "Renta/Hipoteca (Mensual)",
      employer: "Empleador",
      employerType: "Tipo de Empleador",
      monthlyIncome: "Ingreso Mensual",
      occupation: "Ocupación",
      empAddress1: "Dirección del Empleador Línea 1",
      empAddress2: "Dirección del Empleador Línea 2",
      workPhone: "Teléfono de Trabajo",
      jobYears: "Tiempo en Trabajo - Años",
      jobMonths: "Tiempo en Trabajo - Meses",
      landlordName: "Nombre del Arrendador Actual",
      landlordNumber: "Número del Arrendador Actual",
      previousResidenceTitle: "Información Residencial Anterior",
      previousResidenceSubtitle: "Obligatorio porque el tiempo en su residencia actual es menor a 2 años.",
      previousStreetAddress: "Dirección Anterior",
      previousResidenceYears: "Años de Estadía",
      previousResidenceMonths: "Meses de Estadía",
      previousRentMortgage: "Renta / Hipoteca Mensual",
      previousResidenceRequired: "Por favor complete todos los campos de información residencial anterior.",
      previousEmploymentTitle: "Información de Empleo Anterior",
      previousEmploymentSubtitle: "Obligatorio porque el tiempo en su trabajo actual es menor a 2 años.",
      previousEmployer: "Empleador Anterior",
      previousJobYears: "Años de Empleo",
      previousJobMonths: "Meses de Empleo",
      previousEmploymentRequired: "Por favor complete todos los campos de empleo anterior.",
      stockNumber: "Número de Stock",
      vehicleYear: "Año",
      vehicleMake: "Marca",
      vehicleModel: "Modelo",
      trim: "Versión",
      vin: "VIN",
      mileage: "Millaje",
    },

    // Trade-In Page
    tradeIn: {
      tagline: "Obtenga el Mejor Precio por Su Vehículo",
      title: "Intercambie Su Vehículo",
      description: "Cuéntenos sobre su vehículo actual y le proporcionaremos una oferta competitiva de intercambio. Nuestro equipo evaluará su envío y lo contactará dentro de 24 horas.",
      section1Title: "Sección 1: Información Personal",
      section1Subtitle: "Sus datos de contacto",
      section2Title: "Sección 2: Información del Vehículo",
      section2Subtitle: "Detalles de su vehículo de intercambio",
      section3Title: "Sección 3: Características del Vehículo",
      section3Subtitle: "Seleccione todas las características que apliquen",
      section4Title: "Sección 4: Descripción del Vehículo",
      section4Subtitle: "Proporcione detalles adicionales sobre la condición",
      consentTitle: "Reconocimiento y Consentimiento",
      consentSubtitle: "Por favor revise y acepte el siguiente acuerdo",
      submitBtn: "Enviar Información",
      submitting: "Enviando Información...",
      featuresSelected: "características seleccionadas",
      featureSelected: "característica seleccionada",
      vinPlaceholder: "VIN de 17 caracteres",
      yearPlaceholder: "ej., 2022",
      makePlaceholder: "ej., Toyota",
      modelPlaceholder: "ej., Camry",
      trimPlaceholder: "ej., XSE",
      mileagePlaceholder: "ej., 45000",
      colourPlaceholder: "ej., Plata",
      cylinders: "Cilindros",
      selectCylinders: "Seleccionar Cilindros",
      selectTransmission: "Seleccionar Transmisión",
      selectOption: "Seleccionar Opción",
      financed: "Financiado",
      financedWith: "Financiado Con",
      payOffAmount: "Monto a Pagar",
      accidents: "Accidentes",
      descriptionPlaceholder: "Describa la condición general de su vehículo, modificaciones, reparaciones recientes u otra información relevante...",
    },

    // Pre-Qualification Page
    preQual: {
      tagline: "Pre-Aprobación Rápida y Fácil",
      title: "Pre-Califique Ahora",
      description: "Responda algunas preguntas simples para ver si pre-califica para financiamiento. Esto no afectará su puntaje de crédito.",
      startBtn: "Iniciar Pre-Calificación",
      step: "Paso",
      of: "de",
      nextBtn: "Siguiente",
      previousBtn: "Anterior",
      submitBtn: "Enviar Solicitud",
      submitting: "Enviando...",
      // Steps
      step1Title: "Información Personal",
      step2Title: "Empleo e Ingresos",
      step3Title: "Información de Crédito",
      step4Title: "Vehículo de Interés",
      // Fields
      fullName: "Nombre Completo",
      fullNamePlaceholder: "Su nombre legal completo",
      phone: "Número de Teléfono",
      phonePlaceholder: "(708) 222-6100",
      email: "Correo Electrónico",
      emailPlaceholder: "su@correo.com",
      address: "Dirección Actual",
      addressPlaceholder: "5401 W Cermak Rd, Cicero, IL 60804",
      dob: "Fecha de Nacimiento",
      jobDuration: "¿Cuánto tiempo en su trabajo actual?",
      selectDuration: "Seleccionar duración",
      monthlyIncome: "Ingreso Mensual (antes de impuestos)",
      incomePlaceholder: "Ingrese cantidad",
      hasAutoLoan: "¿Tiene actualmente un préstamo de auto?",
      yes: "Sí",
      no: "No",
      loanBalance: "¿Cuál es su saldo actual del préstamo?",
      creditScore: "¿Cuál es su puntaje de crédito estimado?",
      selectScore: "Seleccionar rango",
      hasCollections: "¿Tiene cobranzas en su crédito?",
      collectionsDetails: "Por favor proporcione detalles sobre cobranzas",
      hasBankruptcies: "¿Tiene bancarrotas abiertas?",
      bankruptcyDetails: "Por favor proporcione detalles sobre bancarrotas",
      hasRepossession: "¿Alguna vez le han embargado un vehículo?",
      repossessionTime: "¿Cuándo ocurrió esto?",
      interestedVehicle: "¿Qué tipo de vehículo le interesa?",
      vehiclePlaceholder: "ej., SUV, Sedán, Camioneta",
      budget: "¿Cuál es su presupuesto?",
      budgetPlaceholder: "Ingrese su presupuesto",
      downPayment: "¿Cuánto puede dar de enganche?",
      downPaymentPlaceholder: "Ingrese enganche",
      payTaxesUpfront: "¿Puede pagar impuestos, título y licencia por adelantado?",
      consentTitle: "Reconocimiento y Consentimiento",
    },

    // Loan Calculator Page
    loanCalc: {
      tagline: "Planifique Su Compra",
      title: "Calculadora de Préstamos",
      description: "Use nuestra calculadora para estimar sus pagos mensuales y encontrar un plan de financiamiento que se ajuste a su presupuesto.",
      vehiclePrice: "Precio del Vehículo",
      downPayment: "Enganche",
      tradeInValue: "Valor de Intercambio",
      interestRate: "Tasa de Interés (APR)",
      loanTerm: "Plazo del Préstamo",
      months: "meses",
      monthlyPayment: "Pago Mensual Estimado",
      loanAmount: "Monto del Préstamo",
      totalInterest: "Interés Total",
      totalCost: "Costo Total",
      applyNow: "Solicitar Financiamiento Ahora",
      disclaimer: "Esta calculadora proporciona solo estimaciones. Las tasas y términos reales pueden variar según la solvencia crediticia y otros factores. Contáctenos para cotizaciones precisas.",
    },

    // Schedule Service Page
    scheduleService: {
      tagline: "Cuidado Experto para Su Vehículo",
      title: "Agendar Servicio",
      description: "Nuestros técnicos certificados están listos para mantener su vehículo en las mejores condiciones. Agende su cita de servicio hoy.",
      section1Title: "Información de Contacto",
      section1Subtitle: "¿Cómo podemos contactarlo?",
      section2Title: "Información del Vehículo",
      section2Subtitle: "Cuéntenos sobre su vehículo",
      section3Title: "Detalles del Servicio",
      section3Subtitle: "¿En qué podemos ayudarle?",
      consentTitle: "Reconocimiento y Consentimiento",
      consentSubtitle: "Por favor revise y acepte el siguiente acuerdo",
      submitBtn: "Agendar Servicio",
      submitting: "Agendando...",
      problemDescription: "Describa el Problema",
      problemPlaceholder: "Por favor describa cualquier problema, síntoma o servicio necesario...",
      preferredDate: "Fecha Preferida de Servicio",
      preferredTime: "Hora Preferida",
      preferredTimeOfContact: "Hora preferida de contacto",
      vehicleBodyType: "¿Cuál es el tipo de carrocería de su vehículo?",
      vehicleBodyPlaceholder: "ej., SUV, Sedán, Camioneta",
      selectTime: "Seleccionar hora",
      successMsg: "¡Cita de servicio agendada exitosamente! Lo contactaremos dentro de 24 horas para confirmar su cita.",
    },

    // Vehicle Modal
    vehicleModal: {
      specifications: "Especificaciones",
      year: "Año",
      mileage: "Millaje",
      fuelType: "Combustible",
      transmission: "Transmisión",
      drivetrain: "Tracción",
      exteriorColor: "Exterior",
      interiorColor: "Interior",
      engine: "Motor",
      features: "Características",
      trim: "Trim",
      bodyType: "Tipo de Carrocería",
      condition: "Condición",
      cylinders: "Cilindros",
      cityMpg: "Ciudad MPG",
      highwayMpg: "Carretera MPG",
      viewMoreDetails: "Ver Más Detalles",
      hideDetails: "Ocultar Detalles",
      viewVehicleDescription: "Ver Descripción del Vehículo",
      hideVehicleDescription: "Ocultar Descripción",
      viewVehiclePage: "Ver Página del Vehículo",
      descriptionHeading: "Descripción del Vehículo",
      getQuote: "Pedir cotización",
      quotePrompt: "Complete el formulario de consulta para recibir una cotización.",
      interestedTitle: "Consultar Sobre Este Vehículo",
      interestedDesc: "Complete el formulario y nos pondremos en contacto pronto.",
      namePlaceholder: "Su nombre",
      emailPlaceholder: "su@correo.com",
      phonePlaceholder: "(708) 222-6100",
      messagePlaceholder: "Estoy interesado en este vehículo...",
      preferredContact: "Método de Contacto Preferido",
      sendInquiry: "Enviar Consulta",
      sending: "Enviando...",
      orCall: "Llamar",
      values: {
        conditionNew: "Nuevo",
        conditionUsed: "Usado",
        conditionCertified: "Certificado Pre-Propietario",
        fuelGasoline: "Gasolina",
        fuelElectric: "Eléctrico",
        fuelDiesel: "Diésel",
        fuelHybrid: "Híbrido",
        transmissionAutomatic: "Automático",
      },
    },

    vehiclePage: {
      breadcrumbInventory: "Inventario",
      photos: "Fotos",
      videos: "Videos",
      photoOf: "de",
      specifications: "Especificaciones completas",
      overview: "Resumen",
      highlights: "Destacados",
      features: "Características y equipo",
      stock: "Stock",
      vin: "VIN",
      plusFees: "Más impuestos y cargos",
      callDealership: "Llamar al concesionario",
      applyFinancing: "Solicitar financiamiento",
      copyLink: "Copiar enlace del vehículo",
      linkCopied: "Enlace copiado",
      share: "Compartir",
      backToInventory: "Volver al inventario",
      notFound: "Este vehículo ya no está publicado.",
      notFoundHint: "Es posible que se haya vendido o retirado. Vea el inventario actual.",
      browseInventory: "Ver inventario",
      inquireHeading: "¿Le interesa este vehículo?",
      inquireHint: "Envíe un mensaje y nuestro equipo le responderá pronto.",
      noPhotos: "Fotos próximamente",
      noFeatures: "Consulte con nuestro equipo la lista completa de equipo.",
      locationLabel: "Visítenos",
      address: "5401 W Cermak Rd, Cicero, IL 60804",
      hours: "Lun–Sáb 10AM – 7PM",
      loading: "Cargando vehículo…",
    },

    // Compare Modal
    compare: {
      title: "Comparar Vehículos",
      vehiclesSelected: "vehículos seleccionados",
      vehicleSelected: "vehículo seleccionado",
      specifications: "Especificaciones",
      features: "Características",
      price: "Precio",
      year: "Año",
      mileage: "Millaje",
      fuelType: "Combustible",
      transmission: "Transmisión",
      drivetrain: "Tracción",
      exteriorColor: "Color Exterior",
      interiorColor: "Color Interior",
      engine: "Motor",
      status: "Estado",
      compareUpTo: "Compare hasta 3 vehículos lado a lado",
      doneComparing: "Terminar Comparación",
    },

    // Common
    common: {
      loading: "Cargando...",
      error: "Ocurrió un error",
      required: "Requerido",
      optional: "Opcional",
      submit: "Enviar",
      cancel: "Cancelar",
      close: "Cerrar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      view: "Ver",
      back: "Atrás",
      next: "Siguiente",
      previous: "Anterior",
      yes: "Sí",
      no: "No",
    },

    // Consent Texts
    consent: {
      acknowledgment: "RECONOCIMIENTO Y CONSENTIMIENTO:",
      financingConsent1: "Certifico que la información anterior está completa y es precisa según mi mejor conocimiento. Los acreedores que reciban esta solicitud la conservarán independientemente de si es aprobada o no. Los acreedores pueden basarse en esta solicitud para decidir si otorgan el crédito solicitado. Las declaraciones falsas pueden someterme a sanciones penales. Autorizo a los acreedores a obtener informes de crédito sobre mí de forma continua durante esta transacción de crédito y a verificar mi historial de crédito y empleo de forma continua durante el plazo de la transacción de crédito. Si esta solicitud es aprobada, autorizo al acreedor a proporcionar información crediticia sobre mí a sus afiliados.",
      financingConsent2: "Al marcar esta casilla, doy mi consentimiento para recibir mensajes de texto de atención al cliente y/o llamadas telefónicas de parte de Drive Now Autohaus o sus empleados al número de teléfono móvil que proporcioné anteriormente. Al optar por participar, entiendo que pueden aplicarse tarifas de mensajes y datos. Este reconocimiento constituye mi consentimiento por escrito para recibir mensajes de texto a mi teléfono celular y llamadas telefónicas, incluidas las comunicaciones enviadas mediante un marcador automático o mensaje pregrabado. Puede retirar su consentimiento en cualquier momento enviando un mensaje de texto con \"STOP\" o \"HELP\" para obtener ayuda. Consulte nuestra",
      privacyPolicy: "política de privacidad",
      privacyPolicyTitle: "Política de Privacidad",
      ackAndConsentLink: "Reconocimiento y Consentimiento",
      agreeTo: "He leído y acepto el",
      and: "y la",
      forMoreInfo: "para más información.",
      tradeInConsent: "Al marcar esta casilla, doy mi consentimiento para recibir mensajes de texto de atención al cliente y/o llamadas telefónicas de parte de Drive Now Autohaus o sus empleados al número de teléfono móvil que proporcioné anteriormente. Al optar por participar, entiendo que pueden aplicarse tarifas de mensajes y datos. Este reconocimiento constituye mi consentimiento por escrito para recibir mensajes de texto a mi teléfono celular y llamadas telefónicas, incluidas las comunicaciones enviadas mediante un marcador automático o mensaje pregrabado. Puede retirar su consentimiento en cualquier momento enviando un mensaje de texto con \"STOP\" o \"HELP\" para obtener ayuda. Consulte nuestra",
      serviceConsent: "Al marcar esta casilla, usted consiente expresamente recibir mensajes de texto de atención al cliente y/o llamadas telefónicas al número proporcionado de parte de Drive Now Autohaus o sus empleados en respuesta a su consulta. Al optar por participar, entiende que no se compartirá información móvil con terceros o afiliados con fines de marketing o promoción. La frecuencia de mensajes varía según el usuario. Pueden aplicarse tarifas de mensajes y datos. Puede retirar su consentimiento en cualquier momento enviando un mensaje de texto con \"STOP\" o \"HELP\" para obtener ayuda. Consulte nuestra Política de Privacidad para más información.",
      formRequired: "Por favor acepte recibir mensajes SMS/de texto y llamadas de Drive Now Autohaus",
      smsProgramNotice: "Acepto recibir mensajes SMS/de texto y llamadas de Drive Now Autohaus sobre mi consulta de vehículo, confirmaciones de citas y seguimientos. La frecuencia de los mensajes varía. Pueden aplicarse tarifas de mensajes y datos. Responda STOP para cancelar, HELP para obtener ayuda. Consulte la",
    },

    // How It Works (Loan Calculator)
    howItWorks: {
      title: "Cómo Funciona",
      step1Title: "1. Ingrese Detalles",
      step1Desc: "Ingrese el monto del préstamo deseado, enganche, tasa de interés y plazo del préstamo.",
      step2Title: "2. Calcule",
      step2Desc: "Nuestra calculadora utiliza fórmulas estándar de la industria para calcular su pago mensual.",
      step3Title: "3. Planifique",
      step3Desc: "Revise el desglose y ajuste los valores para encontrar un pago que se ajuste a su presupuesto.",
    },

    // Vehicle Features (Trade-In)
    vehicleFeatures: {
      "4x4": "4x4",
      "adjustablePedals": "Pedales Ajustables",
      "airConditioning": "Aire Acondicionado",
      "airConditionedSeats": "Asientos Climatizados",
      "alarmSystem": "Sistema de Alarma",
      "alloyWheels": "Rines de Aleación",
      "amFm": "AM/FM",
      "antiLockBrakes": "Frenos ABS",
      "autoClimateControl": "Clima Automático",
      "backUpSonar": "Cámara de Reversa",
      "bedCover": "Cubierta de Caja",
      "bedliner": "Recubrimiento de Caja",
      "bluetooth": "Bluetooth",
      "bucketSeats": "Asientos Tipo Balde",
      "cd": "CD",
      "cdChanger": "Cambiador de CD",
      "convertibleTop": "Techo Convertible",
      "cruiseControl": "Control Crucero",
      "diesel": "Diésel",
      "driverAirbag": "Bolsa de Aire Conductor",
      "extraCab": "Cabina Extra",
      "fogLights": "Faros Antiniebla",
      "heatedSeats": "Asientos Calefactados",
      "keylessEntry": "Entrada Sin Llave",
      "leatherSeats": "Asientos de Piel",
      "luggageRack": "Portaequipajes",
      "memorySeats": "Asientos con Memoria",
      "navigation": "Navegación",
      "passengerAirbag": "Bolsa de Aire Pasajero",
      "powerDoors": "Puertas Eléctricas",
      "powerLocks": "Seguros Eléctricos",
      "powerMirrors": "Espejos Eléctricos",
      "powerSeats": "Asientos Eléctricos",
      "powerTailgate": "Cajuela Eléctrica",
      "powerWindows": "Ventanas Eléctricas",
      "quadSeats": "Asientos Cuádruples",
      "rearAir": "Aire Trasero",
      "rearDefroster": "Desempañador Trasero",
      "rearSpoiler": "Alerón Trasero",
      "runningBoards": "Estribos",
      "satelliteRadio": "Radio Satelital",
      "sideAirbags": "Bolsas de Aire Laterales",
      "sunRoof": "Quemacocos",
      "thirdRowSeat": "Tercera Fila de Asientos",
      "tiltWheel": "Volante Ajustable",
      "tintedWindows": "Vidrios Polarizados",
      "toolBox": "Caja de Herramientas",
      "towPackage": "Paquete de Remolque",
      "tractionControl": "Control de Tracción",
      "tvDvd": "TV/DVD",
      "tvVcr": "TV/VCR",
      "woodgrain": "Acabado Madera",
      "usbPort": "Puerto USB",
      "appleCarPlay": "Apple CarPlay",
      "androidAuto": "Android Auto",
      "laneDepartureWarning": "Alerta de Cambio de Carril",
      "laneDepartureAlert": "Alerta de Cambio de Carril",
      "blindSpotMonitor": "Monitor de Punto Ciego",
      "premiumSound": "Sistema de Sonido Premium",
      "pushButtonStart": "Encendido por Botón",
      "remoteStart": "Arranque Remoto",
      "sportSuspension": "Suspensión Deportiva",
      "ledHeadlights": "Faros LED",
      "adaptiveCruiseControl": "Control Crucero Adaptativo",
      "rearviewCamera": "Cámara Trasera",
      "parkingAssist": "Asistente de Estacionamiento",
      "wirelessCharging": "Carga Inalámbrica",
      "touchscreen": "Pantalla Táctil",
      "premiumAudio": "Audio Premium",
      "heatedSteeringWheel": "Volante Calefactado",
      "ventilatedSeats": "Asientos Ventilados",
      "automaticBraking": "Frenado Automático",
    },
  }
};

export const getTranslation = (language, path) => {
  const keys = path.split('.');
  let result = translations[language];
  for (const key of keys) {
    result = result?.[key];
  }
  return result || path;
};
